/**
 * props: value (string), warn (string), empty (string)
 */
const CPF = ({ value, warn, empty }) => {
  const cpf = (value || "").replace(/[^\d^*]/g, "");

  if (cpf.length === 0) return empty || "";

  if (cpf.length !== 11) return warn ? "Inválido" : cpf;

  return cpf.replace(/(\d{3})(\S{3})(\S{3})(\d{2})/, "$1.$2.$3-$4");
};

export default CPF;
